<template>
        <v-card flat>
            <v-card-title>
      <h3 class="headline mb-0 admin-header">Server Logs</h3>
      <v-btn text icon color="grey lighten-1" @click="refresh"><v-icon>fas fa-sync</v-icon></v-btn>
      <!-- <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fal fa-search"
        placeholder="Search"
        single-line
        hide-details
        clearable
      ></v-text-field> -->
    </v-card-title>
          <v-data-table
            :items="elkLogs"
            :loading="loading"
            :headers="headers"
            :footer-props="{'items-per-page-options': numRowsPerPage}"
            :options.sync="pagination"
            :server-items-length="totalItems"
            class="elevation-1"
          >
            <template v-slot:item.receivedTimestamp="{item}">
              <td>{{ formatDateTime(item.receivedTimestamp) }}</td>
            </template>
            <template v-slot:item.eventTimestamp="{item}">
              <td>{{ formatDateTime(item.eventTimestamp) }}</td>
            </template>
          </v-data-table>
        </v-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
export default {
  props: {
    srcIdFilter: [Number, String],
    numRowsPerPage: {
      type: Array,
      default: () => [5, 10, 25]
    },
    rowsPerPage: {
      type: Number,
      default: 10
    }
  },
  async mounted () {
    this.loading = true
    await this.$store.dispatch('collectors/getElkLogs', {sourceId: this.srcIdFilter, pageSize: this.rowsPerPage, pageNumber: 1});
    this.totalItems = this.elkLogTotal
    this.loading = false
  },
  computed: {
    ...mapGetters('collectors', {
        elkLogs: 'getElkLogs',
        elkLogTotal: 'getElkLogTotal'
    })
  },
  updated() {
      this.totalItems = this.elkLogTotal
  },
  watch: {
      srcIdFilter: {
        async handler () {
          this.loading = true;
          await this.$store.dispatch('collectors/getElkLogs', {sourceId: this.srcIdFilter, pageSize: this.rowsPerPage, pageNumber: 1});
          this.totalItems = this.elkLogTotal;
          this.loading = false;
        }
      },
      pagination: {
        async handler () {
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          this.loading = true
          await this.$store.dispatch('collectors/getElkLogs',
                  {sourceId: this.srcIdFilter,
                    pageSize: rowsPerPage,
                    pageNumber: page,
                    sortBy: [sortBy],
                    sortAsc: !descending})
          this.totalItems = this.elkLogTotal
          this.loading = false
        },
        deep: true
      }
  },
  data() {
    return {
      loading: false,
      search: '',
      totalItems: 0,
      pagination : {'sortBy': ['eventTimestamp'], 'sortDesc': [true], 'rowsPerPage': this.rowsPerPage},
      headers: [
        {text: 'id', align: 'left', sortable: false, value: 'id'},
        {text: 'Received', align: 'left', sortable: false, value: 'receivedTimestamp'},
        {text: 'Event', align: 'left', sortable: false, value: 'eventTimestamp'},
        {text: 'Log Level', align: 'left', sortable: false, value: 'logLevel'},
        {text: 'Source Type', align: 'left', sortable: false, value: 'sourceType'},
        {text: 'Logger', align: 'left', sortable: false, value: 'loggerName'},
        {text: 'Source Org Id', align: 'left', sortable: false, value: 'sourceOrgId'},
        {text: 'Source Id', align: 'left', sortable: false, value: 'sourceId'},
        {text: 'Message', align: 'left', sortable: false, value: 'message'},
        {text: 'User', align: 'left', sortable: false, value: 'userId'},
        {text: 'Process', align: 'left', sortable: false, value: 'processId'},
        {text: 'Thread', align: 'left', sortable: false, value: 'thread'},
        {text: 'Details', align: 'left', sortable: false, value: 'details'},
        ]
    }
  },

  methods: {
    async refresh() {
      this.loading = true
      await this.$store.dispatch('collectors/getElkLogs', {sourceId: this.srcIdFilter, pageSize: this.pagination.rowsPerPage, pageNumber: 1})
      this.totalItems = this.elkLogTotal
      this.loading = false
    },
    formatDateTime(val) {
      return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
    }
  }
}
</script>
<style scope>
.alarm {
  color: red!important;
}
</style>
